import { BONUS_BY_PRODUCT_CARDS_ES_MX } from "#components/bonus-by-product-cards/translations";
import { BONUS_BY_PRODUCT_TABLE_ES_MX } from "#components/tables/reports/bonus-by-product-table/translations";
import { USER_BONUS_TABLE_ES_MX } from "#components/tables/reports/user-bonus-table/translations";
import { vendors_ES_MX } from "#pages/org/vendors/translations";
import { BARS_AND_SECTORS_ES_MX } from "#pages/place/bars/translations/bars-and-sectors-es-mx";
import { BONUS_CATEGORIES_ES_MX } from "#pages/place/bonus-categories/translations/bonus-categories-es-mx";
import { BONUS_REPORT_FOR_PLACE_ES_MX } from "#pages/place/financial-reports/bonus-report-for-place/translations";
import { BONUS_REPORT_ES_MX } from "#pages/place/financial-reports/bonus-report/translations";
import { USED_BONUS_REPORT_ES_MX } from "#pages/place/financial-reports/bonus-report/used-bonus-report/translations";
import { IMPORT_FR_FR } from "#pages/place/purchase-invoice/import-invoice/translations/import-fr-fr";
import { PURCHASE_INVOICE_ES_MX } from "#pages/place/purchase-invoice/translations/purchase-invoice-es-mx";
import { COVERT_ES_MX } from "#pages/place/settings/couvert/translations";
import { TEAM_ES_MX } from "#pages/team/translations/team-es-mx";
import { merge } from "lodash-es";
import { backofficeEsMX as backoffice } from "./backoffice";
import { components } from "./components";
import es_MXJson from "./es-MX.json";
import { eventMX } from "./event";
import { globalKeysES_MX } from "./global-keys";
import { navES_MX } from "./nav";
import { noAuthESMX as noAuth } from "./no-auth";
import { integrations } from "./org/integrations";
import { orgES_MX } from "./org";
import { categories } from "./org/categories";
import { organizationES_MX } from "./organization";
import { placeES_MX } from "./place";
import { delivery } from "./place/delivery";
import { sharedES_MX } from "./shared";
import { storeES_MX } from "./store";
import { REGISTER_EMAIL_ES_MX } from "./recovery/register-email";

const bonusByProduct = merge(
	{
		cards: BONUS_BY_PRODUCT_CARDS_ES_MX,
	},
	BONUS_BY_PRODUCT_TABLE_ES_MX,
);

const financialReport = {
	tabs: {
		bonusByProduct,
	},
};

const es_MX = merge(es_MXJson, {
	backoffice,
	components,
	event: {
		...eventMX,
	},
	nav: navES_MX,
	noAuth,
	org: {
		vendors: vendors_ES_MX,
		integrations,
		categories,
		org: orgES_MX,
	},
	organization: organizationES_MX,
	place: {
		...placeES_MX,
		purchaseInvoiceV2: PURCHASE_INVOICE_ES_MX,
		import: IMPORT_FR_FR,
		delivery,
		bonusCategories: BONUS_CATEGORIES_ES_MX,
		usedBonusReport: USED_BONUS_REPORT_ES_MX,
		userBonusTable: USER_BONUS_TABLE_ES_MX,
		bonusReport: BONUS_REPORT_ES_MX,
		bonusReportForPlace: BONUS_REPORT_FOR_PLACE_ES_MX,
		financialReport,
		barsAndSectors: BARS_AND_SECTORS_ES_MX,
		settings: {
			couvertEdit: COVERT_ES_MX,
		},
	},
	recovery: {
		registerEmail: REGISTER_EMAIL_ES_MX,
	},
	store: storeES_MX,
	team: TEAM_ES_MX,
	globalKeys: globalKeysES_MX,
	shared: sharedES_MX,
});

export { es_MX };
